import { useState, useEffect, useRef } from 'react'
import { User, Menu, LogOut, ChevronDown } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import Notifications from './Notifications'

const TopBar = ({ onMenuClick, title }) => {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [showDropdown, setShowDropdown] = useState(false)
  const dropdownRef = useRef(null)

  const handleLogout = async () => {
    setShowDropdown(false)
    await logout()
    navigate('/login')
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div className="fixed top-0 left-0 right-0 z-50 w-full bg-slate-950/80 backdrop-blur-xl shadow-2xl p-4 flex items-center justify-between border-b border-purple-700/60">
      <div className="flex items-center space-x-4">
        {/* Mobile menu button */}
        <button
          onClick={onMenuClick}
          className="p-2 text-gray-300 hover:text-white transition-colors duration-200 rounded-lg hover:bg-slate-800/80"
        >
          <Menu className="w-6 h-6" />
        </button>
        <h1 className="text-xl lg:text-2xl font-semibold text-white">{title}</h1>
      </div>
      
      <div className="flex items-center space-x-2 lg:space-x-4">
        <Notifications />
        
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="flex items-center space-x-2 p-2 rounded-lg hover:bg-slate-800/80 transition-colors duration-200"
          >
            <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center shadow-md">
              <User className="w-4 h-4 lg:w-5 lg:h-5 text-white" />
            </div>
            <span className="hidden sm:block text-sm font-medium text-gray-200">{user?.email || 'Admin User'}</span>
            <ChevronDown className={`w-4 h-4 text-gray-300 transition-transform duration-200 ${showDropdown ? 'rotate-180' : ''}`} />
          </button>

          {showDropdown && (
            <div className="absolute right-0 mt-2 w-56 bg-slate-900 rounded-lg shadow-xl border border-purple-700/60 overflow-hidden z-50">
              <div className="px-4 py-3 border-b border-slate-700">
                <p className="text-sm font-medium text-white">{user?.email || 'Admin User'}</p>
                <p className="text-xs text-gray-400 mt-1">Admin logged in</p>
              </div>
              <button
                onClick={handleLogout}
                className="w-full flex items-center space-x-2 px-4 py-3 text-sm text-gray-300 hover:bg-slate-800 hover:text-white transition-colors duration-200"
              >
                <LogOut className="w-4 h-4" />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default TopBar
